import { IMeterEnrollment } from '../meter-enrollment/interface';
import { INominationReadinessTrack } from './readiness/interface';

export enum NominationRecency {
    PAST = 'past',
    CURRENT = 'current',
    FUTURE = 'future',
}

export const NOMINATION_RECENCY_TEXT_MAP: { [key: string]: string } = {
    [NominationRecency.PAST]: 'Past',
    [NominationRecency.CURRENT]: 'Current',
    [NominationRecency.FUTURE]: 'Future',
};

export const NOMINATION_RECENCY_FILTER_VALUES = [
    { text: NOMINATION_RECENCY_TEXT_MAP[NominationRecency.PAST], value: NominationRecency.PAST },
    { text: NOMINATION_RECENCY_TEXT_MAP[NominationRecency.CURRENT], value: NominationRecency.CURRENT },
    { text: NOMINATION_RECENCY_TEXT_MAP[NominationRecency.FUTURE], value: NominationRecency.FUTURE },
];

export interface INomination {
    salesforce_id: string;
    meter_enrollment_salesforce_id?: string;
    meter_enrollment?: IMeterEnrollment;
    name: string;
    nomination_kw: number;
    performance_kw: number | null;
    performance_percentage: number | null;
    recency: NominationRecency;
    start_date?: string;
    end_date?: string;
    date_created?: string;
    date_modified?: string;
    latestReadinessTrack?: INominationReadinessTrack | null;
    isLatestReadinessTrackOutdated: boolean;
}
